import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-cream px-3 py-16 sm:px-5 sm:py-24" data-id="element-117" data-mp="1clpk2p8rc6uk">
      <div className="mx-auto max-w-4xl" data-id="element-118" data-mp="18k49xbnly6o2">
        <div className="px-2" data-id="element-119" data-mp="18lfh7lg9hwjx">
          <SectionHeading eyebrow="Exclusive bonuses" title={<>
                Get <em className="text-brand-700" data-id="element-121" data-mp="20b0gxvmzlh3f">5 bonuses free</em> today
              </>} data-id="element-120" data-mp="259v4tbzt9vue" />
        </div>
        <div className="mt-10 space-y-8" data-id="element-122" data-mp="1w842mh4hc75a">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_20px_40px_-24px_rgba(38,17,74,0.35)] ring-1 ring-brand-100" data-id="element-123" data-mp="1ralqyiz2vdtl">
              <img src={b.image} alt={`Bonus ${b.number}: ${b.title}`} className="h-auto w-full bg-white" loading="lazy" data-id="element-124" data-mp="kvba343v7eo6" />
              <div className="border-t border-brand-100 p-6 sm:p-8" data-id="element-125" data-mp="1etnb885uxbms">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-700 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white" data-id="element-126" data-mp="1eug90jmu8qss">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-127" data-mp="15trvrr59qugy" />
                  Bonus #{b.number}
                </span>
                <h3 className="mt-3 font-display text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-128" data-mp="1aqibgdd5vo1u">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink-soft" data-id="element-129" data-mp="w12nf550lwpu">{b.text}</p>
                <ul className="mt-5 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-130" data-mp="10v6vxstxict1">
                  {b.includes.map(item => <li key={item} className="flex items-start gap-2.5 text-[16px] text-ink" data-id="element-131" data-mp="r42f0nkp0hvk">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-132" data-mp="r1py8dqo8dk3" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-6 inline-block rounded-lg bg-cta/10 px-3 py-1.5 text-sm font-extrabold uppercase tracking-wide text-cta-dark" data-id="element-133" data-mp="2jsjwylljvnjz">
                  Included free today
                </p>
              </div>
            </article>)}
        </div>
        <div className="px-2" data-id="element-134" data-mp="2b0hwwofe89a8">
          <CtaButton label="I want all 5 bonuses free" className="mt-12" data-id="element-135" data-mp="2615fij7ajuf1" />
        </div>
      </div>
    </section>;
}